import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiMembersInsightPostsLikedEmployeesIndexResponseType } from "~/domains";

type RequestDataType = {
  insightPostId: string;
  page?: number;
};

const request = async ({
  insightPostId,
  page = 1,
}: RequestDataType): Promise<ApiMembersInsightPostsLikedEmployeesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersInsightPostsLikedEmployeesIndexResponseType>(
      `/api/members/insight_posts/${insightPostId}/liked_employees`,
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  insightPostId: string;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisMembersInsightPostsLikedEmployeesIndex = ({
  insightPostId,
  config = {},
}: PropsType): UseInfiniteQueryResult<ApiMembersInsightPostsLikedEmployeesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisMembersInsightPostsLikedEmployeesIndex", insightPostId],
    ({ pageParam }) => {
      return request({ insightPostId, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
